export const Pages={
  size:100,
  debounceTime:300,
  logo:'../../../assets/images/logo.jpg'
}
